import script from "./MenuTarefasAcao.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuTarefasAcao.vue?vue&type=script&setup=true&lang=js"

import "./MenuTarefasAcao.vue?vue&type=style&index=0&id=a3cdbbf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3cdbbf0"]])

export default __exports__